/**
 * @generated SignedSource<<66a9af7fc8956c7a6e6dbadb45e608ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OrderEnum = "ASC" | "DESC";
export type TermObjectsConnectionOrderbyEnum = "COUNT" | "DESCRIPTION" | "NAME" | "SLUG" | "TERM_GROUP" | "TERM_ID" | "TERM_ORDER";
export type RootQueryToTagConnectionWhereArgs = {
  cacheDomain?: string | null | undefined;
  childOf?: number | null | undefined;
  childless?: boolean | null | undefined;
  descriptionLike?: string | null | undefined;
  exclude?: ReadonlyArray<string | null | undefined> | null | undefined;
  excludeTree?: ReadonlyArray<string | null | undefined> | null | undefined;
  hideEmpty?: boolean | null | undefined;
  hierarchical?: boolean | null | undefined;
  include?: ReadonlyArray<string | null | undefined> | null | undefined;
  name?: ReadonlyArray<string | null | undefined> | null | undefined;
  nameLike?: string | null | undefined;
  objectIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  order?: OrderEnum | null | undefined;
  orderby?: TermObjectsConnectionOrderbyEnum | null | undefined;
  padCounts?: boolean | null | undefined;
  parent?: number | null | undefined;
  search?: string | null | undefined;
  slug?: ReadonlyArray<string | null | undefined> | null | undefined;
  termTaxonomyId?: ReadonlyArray<string | null | undefined> | null | undefined;
  updateTermMetaCache?: boolean | null | undefined;
};
export type Tag_Search_Query$variables = {
  after?: string | null | undefined;
  first?: number | null | undefined;
  where?: RootQueryToTagConnectionWhereArgs | null | undefined;
};
export type Tag_Search_Query$data = {
  readonly tags: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string | null | undefined;
      };
    }>;
  } | null | undefined;
};
export type Tag_Search_Query = {
  response: Tag_Search_Query$data;
  variables: Tag_Search_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": 12,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "where"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "where",
        "variableName": "where"
      }
    ],
    "concreteType": "RootQueryToTagConnection",
    "kind": "LinkedField",
    "name": "tags",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RootQueryToTagConnectionEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Tag",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "Tag_Search_Query",
    "selections": (v3/*: any*/),
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "Tag_Search_Query",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "034df6935b356a0581859326d885beb5",
    "id": null,
    "metadata": {},
    "name": "Tag_Search_Query",
    "operationKind": "query",
    "text": "query Tag_Search_Query(\n  $first: Int = 12\n  $after: String\n  $where: RootQueryToTagConnectionWhereArgs\n) {\n  tags(first: $first, after: $after, where: $where) {\n    edges {\n      node {\n        name\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "062f51727544c2c3ed587766dccd5f5c";

export default node;
